import React from 'react';

const ScorecardPage = React.lazy(() => import('pages/scorecard'));

const policies = [{ resource: 'reportsScorecard', action: 'view' }];

export const definitions = [
  {
    index: true,
    policies: policies,
    component: <ScorecardPage />
  }
];
